// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"214":"b963bb3365e3615c","2194":"b963bb3365e3615c","2888":"5ae9d33970a1314a","7440":"b963bb3365e3615c"}[chunkId] + ".css";
};